
<template>
  <v-app class="bg">
    <card-login>
      <template v-slot:text>
        <span class="d-flex justify-center text-h6">Token inválido</span>
      </template>
      <template v-slot:control>
        <v-row>
          <v-col>
          </v-col>
        </v-row>
        <v-row>
        </v-row>
      </template>
    </card-login>
  </v-app>
</template>

<script>

export default {
  name: 'ClientOrderUnauthorized',
  components: {
    CardLogin: () => import("@/_auth/components/containers/AuthCard.vue"),
  },
}
</script>

<style scoped>
  .bg{
    background-color: #E53935 !important;
  }
</style>